import { createEnv } from "@t3-oss/env-nextjs";
import { z } from "zod";

export const env = createEnv({
	server: {
		NODE_ENV: z.enum(["development", "production"]).default("development"),

		ASAAS_API_KEY: z.string().min(1),
		ASAAS_BASE_URL: z.string().min(1),
		ASAAS_WEBHOOK_TOKEN: z.string().min(1),

		AWS_ACCESS_KEY_ID: z.string().min(1),
		AWS_SECRET_ACCESS_KEY: z.string().min(1),
		AWS_REGION: z.string().min(1),
		AWS_S3_BUCKET: z.string().min(1),

		MONGODB_URI: z.string().min(1),

		RESEND_API_KEY: z.string().min(1),
		RESEND_FROM_EMAIL: z.string().min(1),
		RESEND_TO_EMAIL: z.string().min(1),

		BASE_PRICE: z.coerce.number().min(0),
		TIKTOK_TOKEN: z.string().min(1),
		META_CAPI_TOKEN: z.string().min(1).optional(),
		META_CAPI_TOKENS_BY_PIXEL: z.string().min(1).optional(),
	},
	client: {
		NEXT_PUBLIC_BASE_URL: z.url(),
		NEXT_PUBLIC_GA_ID: z.string().min(1),
		NEXT_PUBLIC_META_PIXEL_IDS: z.string().min(1).optional(),
		NEXT_PUBLIC_POSTHOG_KEY: z.string().min(1),
		NEXT_PUBLIC_POSTHOG_HOST: z.string().url(),
	},
	// If you're using Next.js < 13.4.4, you'll need to specify the runtimeEnv manually
	// runtimeEnv: {
	// 	DATABASE_URL: process.env.DATABASE_URL,
	// 	OPEN_AI_API_KEY: process.env.OPEN_AI_API_KEY,
	// 	NEXT_PUBLIC_PUBLISHABLE_KEY: process.env.NEXT_PUBLIC_PUBLISHABLE_KEY,
	// },
	// For Next.js >= 13.4.4, you only need to destructure client variables:
	experimental__runtimeEnv: {
		NEXT_PUBLIC_BASE_URL: process.env.NEXT_PUBLIC_BASE_URL,
		NEXT_PUBLIC_GA_ID: process.env.NEXT_PUBLIC_GA_ID,
		NEXT_PUBLIC_META_PIXEL_IDS: process.env.NEXT_PUBLIC_META_PIXEL_IDS,
		NEXT_PUBLIC_POSTHOG_KEY: process.env.NEXT_PUBLIC_POSTHOG_KEY,
		NEXT_PUBLIC_POSTHOG_HOST: process.env.NEXT_PUBLIC_POSTHOG_HOST,
	},
});
